import * as common from '../common/common';
export var GroupCreatorTypeApi;
(function (GroupCreatorTypeApi) {
    GroupCreatorTypeApi["ADMIN"] = "admin";
    GroupCreatorTypeApi["USER"] = "user";
})(GroupCreatorTypeApi || (GroupCreatorTypeApi = {}));
export var GroupStatusApi;
(function (GroupStatusApi) {
    GroupStatusApi["LIVE"] = "live";
    GroupStatusApi["IN_REVIEW"] = "in_review";
})(GroupStatusApi || (GroupStatusApi = {}));
export var GroupTypeApi;
(function (GroupTypeApi) {
    GroupTypeApi["TALENT_POOL"] = "talent_pool";
    GroupTypeApi["COMMUNITY"] = "community";
    GroupTypeApi["WORKROOM"] = "workroom";
    GroupTypeApi["OFFICIAL"] = "official";
    GroupTypeApi["PUBLIC"] = "public";
    GroupTypeApi["PRIVATE"] = "private";
    GroupTypeApi["TALENT_STAGING"] = "talent_staging";
})(GroupTypeApi || (GroupTypeApi = {}));
export var GroupMemberStatusApi;
(function (GroupMemberStatusApi) {
    GroupMemberStatusApi["IS_MEMBER"] = "is_member";
    GroupMemberStatusApi["NOT_MEMBER"] = "not_member";
})(GroupMemberStatusApi || (GroupMemberStatusApi = {}));
export var GroupMemberRoleApi;
(function (GroupMemberRoleApi) {
    GroupMemberRoleApi["MEMBER"] = "member";
    GroupMemberRoleApi["ADMIN"] = "admin";
    GroupMemberRoleApi["GUEST"] = "guest";
    GroupMemberRoleApi["MODERATOR"] = "moderator";
    GroupMemberRoleApi["MUTED"] = "muted";
})(GroupMemberRoleApi || (GroupMemberRoleApi = {}));
export var GroupActionSourceTypeApi;
(function (GroupActionSourceTypeApi) {
    GroupActionSourceTypeApi["ADMIN"] = "admin";
    GroupActionSourceTypeApi["USER"] = "user";
})(GroupActionSourceTypeApi || (GroupActionSourceTypeApi = {}));
export var GroupActionRefTypeApi;
(function (GroupActionRefTypeApi) {
    GroupActionRefTypeApi["GROUP_MEMBER"] = "group_member";
    GroupActionRefTypeApi["PROJECT"] = "project";
})(GroupActionRefTypeApi || (GroupActionRefTypeApi = {}));
export var GroupActionApi;
(function (GroupActionApi) {
    GroupActionApi["GROUP_CREATE"] = "group_create";
    GroupActionApi["GROUP_UPDATE"] = "group_update";
    GroupActionApi["GROUP_DELETE"] = "group_delete";
    GroupActionApi["GROUP_MEMBER_ADD"] = "group_member_add";
    GroupActionApi["GROUP_MEMBER_REMOVE"] = "group_member_remove";
    GroupActionApi["GROUP_MEMBER_UPDATE"] = "group_member_update";
    GroupActionApi["GROUP_PERMISSION_UPDATE"] = "group_permission_update";
    GroupActionApi["GROUP_POOL_UPDATE"] = "group_pool_update";
    GroupActionApi["PROJECT_GROUP_CREATE"] = "project_group_create";
    GroupActionApi["PROJECT_GROUP_DELETE"] = "project_group_delete";
})(GroupActionApi || (GroupActionApi = {}));
export var GroupActionDetailApi;
(function (GroupActionDetailApi) {
    GroupActionDetailApi["GROUP_TITLE"] = "group_title";
    GroupActionDetailApi["GROUP_DESCRIPTION"] = "group_description";
    GroupActionDetailApi["GROUP_SEO_URL"] = "group_seo_url";
    GroupActionDetailApi["GROUP_MEMBER_ROLE"] = "group_member_role";
    GroupActionDetailApi["JSON"] = "json";
})(GroupActionDetailApi || (GroupActionDetailApi = {}));
export var AttachmentAttachedToTypeApi;
(function (AttachmentAttachedToTypeApi) {
    AttachmentAttachedToTypeApi["POST"] = "post";
    AttachmentAttachedToTypeApi["COMMENT"] = "comment";
})(AttachmentAttachedToTypeApi || (AttachmentAttachedToTypeApi = {}));
export var AttachmentsTypeApi;
(function (AttachmentsTypeApi) {
    AttachmentsTypeApi["ALL"] = "all";
    AttachmentsTypeApi["MEDIA"] = "media";
    AttachmentsTypeApi["FILE"] = "file";
})(AttachmentsTypeApi || (AttachmentsTypeApi = {}));
export var GroupPermissionApi;
(function (GroupPermissionApi) {
    GroupPermissionApi["POST_DELETE"] = "post_delete";
    GroupPermissionApi["COVER_IMAGE_EDIT"] = "cover_image_edit";
    GroupPermissionApi["POST_CREATE"] = "post_create";
    GroupPermissionApi["POST_ANY_DELETE"] = "post_any_delete";
    GroupPermissionApi["POST_OWN_EDIT"] = "post_own_edit";
    GroupPermissionApi["POST_OWN_DELETE"] = "post_own_delete";
    GroupPermissionApi["POSTS_ALL_DELETE"] = "posts_all_delete";
    GroupPermissionApi["POST_REPORT"] = "post_report";
    GroupPermissionApi["POST_REACT"] = "post_react";
    GroupPermissionApi["POST_CREATE_BY_TRUSTED_USER"] = "post_create_by_trusted_user";
    GroupPermissionApi["COMMENT_CREATE"] = "comment_create";
    GroupPermissionApi["COMMENT_OWN_EDIT"] = "comment_own_edit";
    GroupPermissionApi["COMMENT_OWN_DELETE"] = "comment_own_delete";
    GroupPermissionApi["COMMENT_ANY_DELETE"] = "comment_any_delete";
    GroupPermissionApi["COMMENTS_ALL_DELETE"] = "comments_all_delete";
    GroupPermissionApi["COMMENT_REPORT"] = "comment_report";
    GroupPermissionApi["COMMENT_REACT"] = "comment_react";
    GroupPermissionApi["COMMENT_DISABLE"] = "comment_disable";
    GroupPermissionApi["COMMENT_CREATE_BY_TRUSTED_USER"] = "comment_create_by_trusted_user";
    GroupPermissionApi["USER_INVITE"] = "user_invite";
    GroupPermissionApi["USER_WARN"] = "user_warn";
    GroupPermissionApi["USER_KICK"] = "user_kick";
    GroupPermissionApi["USER_BAN"] = "user_ban";
    GroupPermissionApi["USER_MUTE"] = "user_mute";
    GroupPermissionApi["MEMBERS_GET_BY_ROLES"] = "members_get_by_roles";
    GroupPermissionApi["FEED_GET"] = "feed_get";
    GroupPermissionApi["CHANGE_MODERATOR_RIGHTS"] = "change_moderator_rights";
})(GroupPermissionApi || (GroupPermissionApi = {}));
export var GroupMemberRemoveReasonApi;
(function (GroupMemberRemoveReasonApi) {
    GroupMemberRemoveReasonApi["SPAM"] = "spam";
    GroupMemberRemoveReasonApi["DISCLOSING_PERSONAL_DETAILS"] = "disclosing_personal_details";
    GroupMemberRemoveReasonApi["SCAM"] = "scam";
    GroupMemberRemoveReasonApi["OFFENSIVE"] = "offensive";
    GroupMemberRemoveReasonApi["HARASSMENT"] = "harassment";
    GroupMemberRemoveReasonApi["OTHER"] = "other";
    GroupMemberRemoveReasonApi["LEAVE"] = "leave";
    GroupMemberRemoveReasonApi["IRRELEVANT"] = "irrelevant";
})(GroupMemberRemoveReasonApi || (GroupMemberRemoveReasonApi = {}));
export const RemovalReasonToGroupMemberRemoveReasonApi = {
    [common.RemovalReasonApi.SPAM]: GroupMemberRemoveReasonApi.SPAM,
    [common.RemovalReasonApi.DISCLOSING_PERSONAL_DETAILS]: GroupMemberRemoveReasonApi.DISCLOSING_PERSONAL_DETAILS,
    [common.RemovalReasonApi.SCAM]: GroupMemberRemoveReasonApi.SCAM,
    [common.RemovalReasonApi.OFFENSIVE]: GroupMemberRemoveReasonApi.OFFENSIVE,
    [common.RemovalReasonApi.HARASSMENT]: GroupMemberRemoveReasonApi.HARASSMENT,
    [common.RemovalReasonApi.OTHER]: GroupMemberRemoveReasonApi.OTHER,
    [common.RemovalReasonApi.OWNER_DELETE]: GroupMemberRemoveReasonApi.LEAVE,
    [common.RemovalReasonApi.IRRELEVANT]: GroupMemberRemoveReasonApi.IRRELEVANT,
};
export const UNRESTRICTED_GROUPSApi = [
    GroupTypeApi.PUBLIC,
    GroupTypeApi.COMMUNITY,
    GroupTypeApi.OFFICIAL,
];
export const GROUP_DEFAULT_PERMISSIONSApi = {
    [GroupMemberRoleApi.ADMIN]: {
        [GroupPermissionApi.POST_DELETE]: true,
        [GroupPermissionApi.POSTS_ALL_DELETE]: true,
        [GroupPermissionApi.POST_ANY_DELETE]: true,
        [GroupPermissionApi.POST_CREATE]: true,
        [GroupPermissionApi.POST_REACT]: true,
        [GroupPermissionApi.POST_OWN_DELETE]: true,
        [GroupPermissionApi.POST_OWN_EDIT]: true,
        [GroupPermissionApi.POST_REPORT]: true,
        [GroupPermissionApi.POST_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.COMMENTS_ALL_DELETE]: true,
        [GroupPermissionApi.COMMENT_ANY_DELETE]: true,
        [GroupPermissionApi.COMMENT_CREATE]: true,
        [GroupPermissionApi.COMMENT_DISABLE]: true,
        [GroupPermissionApi.COMMENT_REACT]: true,
        [GroupPermissionApi.COMMENT_OWN_DELETE]: true,
        [GroupPermissionApi.COMMENT_OWN_EDIT]: true,
        [GroupPermissionApi.COMMENT_REPORT]: true,
        [GroupPermissionApi.COMMENT_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.USER_BAN]: true,
        [GroupPermissionApi.USER_INVITE]: true,
        [GroupPermissionApi.USER_KICK]: true,
        [GroupPermissionApi.USER_WARN]: true,
        [GroupPermissionApi.USER_MUTE]: true,
        [GroupPermissionApi.MEMBERS_GET_BY_ROLES]: true,
        [GroupPermissionApi.FEED_GET]: true,
        [GroupPermissionApi.CHANGE_MODERATOR_RIGHTS]: true,
        [GroupPermissionApi.COVER_IMAGE_EDIT]: true,
    },
    [GroupMemberRoleApi.MODERATOR]: {
        [GroupPermissionApi.POSTS_ALL_DELETE]: true,
        [GroupPermissionApi.POST_ANY_DELETE]: true,
        [GroupPermissionApi.POST_CREATE]: true,
        [GroupPermissionApi.POST_REACT]: true,
        [GroupPermissionApi.POST_OWN_DELETE]: true,
        [GroupPermissionApi.POST_OWN_EDIT]: true,
        [GroupPermissionApi.POST_REPORT]: true,
        [GroupPermissionApi.POST_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.COMMENTS_ALL_DELETE]: true,
        [GroupPermissionApi.COMMENT_ANY_DELETE]: true,
        [GroupPermissionApi.COMMENT_CREATE]: true,
        [GroupPermissionApi.COMMENT_DISABLE]: true,
        [GroupPermissionApi.COMMENT_REACT]: true,
        [GroupPermissionApi.COMMENT_OWN_DELETE]: true,
        [GroupPermissionApi.COMMENT_OWN_EDIT]: true,
        [GroupPermissionApi.COMMENT_REPORT]: true,
        [GroupPermissionApi.COMMENT_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.USER_BAN]: false,
        [GroupPermissionApi.USER_INVITE]: true,
        [GroupPermissionApi.USER_KICK]: false,
        [GroupPermissionApi.USER_WARN]: true,
        [GroupPermissionApi.USER_MUTE]: true,
        [GroupPermissionApi.MEMBERS_GET_BY_ROLES]: true,
        [GroupPermissionApi.FEED_GET]: true,
        [GroupPermissionApi.CHANGE_MODERATOR_RIGHTS]: false,
        [GroupPermissionApi.COVER_IMAGE_EDIT]: false,
    },
    [GroupMemberRoleApi.MEMBER]: {
        [GroupPermissionApi.POST_DELETE]: false,
        [GroupPermissionApi.POSTS_ALL_DELETE]: false,
        [GroupPermissionApi.POST_ANY_DELETE]: false,
        [GroupPermissionApi.POST_CREATE]: false,
        [GroupPermissionApi.POST_REACT]: true,
        [GroupPermissionApi.POST_OWN_DELETE]: true,
        [GroupPermissionApi.POST_OWN_EDIT]: true,
        [GroupPermissionApi.POST_REPORT]: true,
        [GroupPermissionApi.POST_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.COMMENTS_ALL_DELETE]: false,
        [GroupPermissionApi.COMMENT_ANY_DELETE]: false,
        [GroupPermissionApi.COMMENT_CREATE]: true,
        [GroupPermissionApi.COMMENT_DISABLE]: false,
        [GroupPermissionApi.COMMENT_REACT]: true,
        [GroupPermissionApi.COMMENT_OWN_DELETE]: true,
        [GroupPermissionApi.COMMENT_OWN_EDIT]: true,
        [GroupPermissionApi.COMMENT_REPORT]: true,
        [GroupPermissionApi.COMMENT_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.USER_BAN]: false,
        [GroupPermissionApi.USER_INVITE]: true,
        [GroupPermissionApi.USER_KICK]: false,
        [GroupPermissionApi.USER_WARN]: false,
        [GroupPermissionApi.USER_MUTE]: false,
        [GroupPermissionApi.MEMBERS_GET_BY_ROLES]: true,
        [GroupPermissionApi.FEED_GET]: true,
        [GroupPermissionApi.CHANGE_MODERATOR_RIGHTS]: false,
        [GroupPermissionApi.COVER_IMAGE_EDIT]: false,
    },
    [GroupMemberRoleApi.GUEST]: {
        [GroupPermissionApi.POSTS_ALL_DELETE]: false,
        [GroupPermissionApi.POST_ANY_DELETE]: false,
        [GroupPermissionApi.POST_CREATE]: false,
        [GroupPermissionApi.POST_REACT]: true,
        [GroupPermissionApi.POST_OWN_DELETE]: false,
        [GroupPermissionApi.POST_OWN_EDIT]: false,
        [GroupPermissionApi.POST_REPORT]: true,
        [GroupPermissionApi.POST_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.COMMENTS_ALL_DELETE]: false,
        [GroupPermissionApi.COMMENT_ANY_DELETE]: false,
        [GroupPermissionApi.COMMENT_CREATE]: false,
        [GroupPermissionApi.COMMENT_DISABLE]: false,
        [GroupPermissionApi.COMMENT_REACT]: true,
        [GroupPermissionApi.COMMENT_OWN_DELETE]: false,
        [GroupPermissionApi.COMMENT_OWN_EDIT]: false,
        [GroupPermissionApi.COMMENT_REPORT]: true,
        [GroupPermissionApi.COMMENT_CREATE_BY_TRUSTED_USER]: true,
        [GroupPermissionApi.USER_BAN]: false,
        [GroupPermissionApi.USER_INVITE]: false,
        [GroupPermissionApi.USER_KICK]: false,
        [GroupPermissionApi.USER_WARN]: false,
        [GroupPermissionApi.USER_MUTE]: false,
        [GroupPermissionApi.MEMBERS_GET_BY_ROLES]: false,
        [GroupPermissionApi.FEED_GET]: true,
        [GroupPermissionApi.CHANGE_MODERATOR_RIGHTS]: false,
        [GroupPermissionApi.COVER_IMAGE_EDIT]: false,
    },
    [GroupMemberRoleApi.MUTED]: {
        [GroupPermissionApi.POSTS_ALL_DELETE]: false,
        [GroupPermissionApi.POST_ANY_DELETE]: false,
        [GroupPermissionApi.POST_CREATE]: false,
        [GroupPermissionApi.POST_REACT]: true,
        [GroupPermissionApi.POST_OWN_DELETE]: true,
        [GroupPermissionApi.POST_OWN_EDIT]: false,
        [GroupPermissionApi.POST_REPORT]: false,
        [GroupPermissionApi.POST_CREATE_BY_TRUSTED_USER]: false,
        [GroupPermissionApi.COMMENTS_ALL_DELETE]: false,
        [GroupPermissionApi.COMMENT_ANY_DELETE]: false,
        [GroupPermissionApi.COMMENT_CREATE]: false,
        [GroupPermissionApi.COMMENT_DISABLE]: false,
        [GroupPermissionApi.COMMENT_REACT]: true,
        [GroupPermissionApi.COMMENT_OWN_DELETE]: true,
        [GroupPermissionApi.COMMENT_OWN_EDIT]: false,
        [GroupPermissionApi.COMMENT_REPORT]: false,
        [GroupPermissionApi.COMMENT_CREATE_BY_TRUSTED_USER]: false,
        [GroupPermissionApi.USER_BAN]: false,
        [GroupPermissionApi.USER_INVITE]: false,
        [GroupPermissionApi.USER_KICK]: false,
        [GroupPermissionApi.USER_WARN]: false,
        [GroupPermissionApi.USER_MUTE]: false,
        [GroupPermissionApi.MEMBERS_GET_BY_ROLES]: false,
        [GroupPermissionApi.FEED_GET]: true,
        [GroupPermissionApi.CHANGE_MODERATOR_RIGHTS]: false,
        [GroupPermissionApi.COVER_IMAGE_EDIT]: false,
    },
};
export const ATTACHMENTS_TYPE_MIMEApi = {
    [AttachmentsTypeApi.MEDIA]: ['image/gif', 'image/jpeg', 'image/png'],
    [AttachmentsTypeApi.FILE]: [
        'application/javascript',
        'application/msword',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/csv',
        'text/html',
        'text/plain',
        'text/x-diff',
    ],
};
export var GroupIsDeletedFilterOptionApi;
(function (GroupIsDeletedFilterOptionApi) {
    GroupIsDeletedFilterOptionApi["NOT_DELETED"] = "not_deleted";
    GroupIsDeletedFilterOptionApi["DELETED"] = "deleted";
    GroupIsDeletedFilterOptionApi["ALL"] = "all";
})(GroupIsDeletedFilterOptionApi || (GroupIsDeletedFilterOptionApi = {}));
export var GroupActionLogsOrderApi;
(function (GroupActionLogsOrderApi) {
    GroupActionLogsOrderApi["ID_DESC"] = "id_desc";
})(GroupActionLogsOrderApi || (GroupActionLogsOrderApi = {}));
export var GroupAttachmentsOrderOptionApi;
(function (GroupAttachmentsOrderOptionApi) {
    GroupAttachmentsOrderOptionApi["ID"] = "id";
    GroupAttachmentsOrderOptionApi["CREATED"] = "created";
    GroupAttachmentsOrderOptionApi["FILE_NAME"] = "file_name";
    GroupAttachmentsOrderOptionApi["FILE_SIZE"] = "file_size";
})(GroupAttachmentsOrderOptionApi || (GroupAttachmentsOrderOptionApi = {}));
export var GroupAttachmentsOrderDirectionApi;
(function (GroupAttachmentsOrderDirectionApi) {
    GroupAttachmentsOrderDirectionApi["ASC"] = "asc";
    GroupAttachmentsOrderDirectionApi["DESC"] = "desc";
})(GroupAttachmentsOrderDirectionApi || (GroupAttachmentsOrderDirectionApi = {}));
export var DefaultGroupContextTypeApi;
(function (DefaultGroupContextTypeApi) {
    DefaultGroupContextTypeApi["POOL"] = "pool";
})(DefaultGroupContextTypeApi || (DefaultGroupContextTypeApi = {}));
export var GroupUserTypeApi;
(function (GroupUserTypeApi) {
    GroupUserTypeApi["EMPLOYER"] = "employer";
    GroupUserTypeApi["FREELANCER"] = "freelancer";
    GroupUserTypeApi["EMAIL_VERIFIED_FREELANCER"] = "email_verified_freelancer";
    GroupUserTypeApi["EMAIL_VERIFIED_EMPLOYER"] = "email_verified_employer";
})(GroupUserTypeApi || (GroupUserTypeApi = {}));
